import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import { ExceptionParser } from '../ExceptionParser';
import { Exception } from './Exception';
import { BackgroundException } from './BackgroundException';
export var LogEntry = /*#__PURE__*/function (_Component) {
  _inherits(LogEntry, _Component);

  var _super = _createSuper(LogEntry);

  function LogEntry() {
    var _this;

    _classCallCheck(this, LogEntry);

    _this = _super.call(this);
    _this.exceptionParser = new ExceptionParser();
    return _this;
  }

  _createClass(LogEntry, [{
    key: "render",
    value: function render() {
      if (this.isBackgroundJobException()) {
        return this.renderBackgroundException();
      } else if (this.isException()) {
        return this.renderException();
      } else {
        return this.renderBasic();
      }
    }
  }, {
    key: "renderBasic",
    value: function renderBasic() {
      return /*#__PURE__*/React.createElement("span", null, this.props.message);
    }
  }, {
    key: "renderException",
    value: function renderException() {
      var _this$props$exception;

      var exceptionData = this.exceptionParser.parse((_this$props$exception = this.props.exception) !== null && _this$props$exception !== void 0 ? _this$props$exception : this.props.message);
      return /*#__PURE__*/React.createElement(Exception, exceptionData);
    }
  }, {
    key: "renderBackgroundException",
    value: function renderBackgroundException() {
      var _this$props$exception2;

      var exceptionData = this.exceptionParser.parse((_this$props$exception2 = this.props.exception) !== null && _this$props$exception2 !== void 0 ? _this$props$exception2 : this.props.message);
      return /*#__PURE__*/React.createElement(BackgroundException, exceptionData);
    }
  }, {
    key: "isBackgroundJobException",
    value: function isBackgroundJobException() {
      var _this$props$exception3;

      return this.exceptionParser.isBackgroundJobException((_this$props$exception3 = this.props.exception) !== null && _this$props$exception3 !== void 0 ? _this$props$exception3 : this.props.message);
    }
  }, {
    key: "isException",
    value: function isException() {
      var _this$props$exception4;

      return this.exceptionParser.isException((_this$props$exception4 = this.props.exception) !== null && _this$props$exception4 !== void 0 ? _this$props$exception4 : this.props.message);
    }
  }]);

  return LogEntry;
}(Component);